export default function dropdownMenu() {
  const hamburgerIcon = document.getElementById("js_hamburger_icon");
  const navContainer = document.getElementById("js_nav_dropdown_container");

  // if the client language contains CA (Canada) or fr (French langauge), show
  // Canada nav dropdown item. Why show for `fr` when `CA` should cover all of
  // Canada? Because in my single test of a Quebec client the language was
  // fr-FR
  if (/fr|CA/.test(window.navigator.language)) {
    document.querySelector(".canada").style.display = "block";
  }

  // open nav menu when hamburger menu is clicked on
  hamburgerIcon.addEventListener("click", (e) => {
    e.stopPropagation();
    navContainer.classList.add("active");
    document.body.classList.add("no_scroll");
  });

  // hide nav menu when something outside the dropdown menu is clicked
  navContainer.addEventListener("click", (e) => {
    if (e.target.id === "js_nav_dropdown_container") {
      navContainer.classList.remove("active");
      document.body.classList.remove("no_scroll");
    }
  });
}
